// extracted by mini-css-extract-plugin
module.exports = {"container":"Container-module--container--2Ivwx","bigContainer":"Container-module--big-container--29MU9","mobileContainer":"Container-module--mobile-container--RYrbo"};